export default "__VITE_ASSET__B360jR14__"